import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import YourHomePerfectlyFitted from "./sections/YourHomePerfectlyFitted";
import ParadisePalmsExperience from "./sections/ParadisePalmsExperience";
import ThePhotoshootSeries from "./sections/ThePhotoshootSeries";
import ServiceExperiences from "./sections/ServiceExperiences";
import WhyThisWorkIsDifferent from "./sections/WhyThisWorkIsDifferent";
import CommonQuestions from "./sections/CommonQuestions";
import ReserveYourTable from "./sections/ReserveYourTable";
import Pricing from "./sections/Pricing";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <YourHomePerfectlyFitted />
      <ParadisePalmsExperience />
      <ThePhotoshootSeries />
      <ServiceExperiences />
      <WhyThisWorkIsDifferent />
      <CommonQuestions />
      <Pricing />
      <ReserveYourTable />
      <SiteFooter />
    </div>;
}